<!-- 最新更新 -->
<template>
	<div class="latest-updates-wrap">
		<!-- 头部 -->
		<TopHeader />

		<!-- banner -->
		<Banner />

		<!-- 面包屑 -->
		<div class="breadcrumb-wrap">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item>最新更新</el-breadcrumb-item>
			</el-breadcrumb>
			<a href="https://www.tunnelling.cn/PMember/mybooklist.aspx" target="_blank">我的知识平台</a>
		</div>

		<!-- 内容 -->
		<div class="content-box">
			<!-- 左部分内容 -->
			<div class="left-cont-box">
				<!-- 标题 -->
				<ItemTitle title="最新更新" :margin-top="0" />

				<!-- 列表 -->
				<div class="list-box">
					<router-link class="item" v-for="(item, index) in updatesList" :key="index"
						:to="{ path:'/bookDetail', query: { InformationId: item.id } }">
						<div class="item-img">
							<img class="cover" :src="item.imagePath" :onerror="defaultImg" />
							<!-- new标识 -->
							<img v-if="item.isNew" class="new-mark" src="../../assets/img/new-mark.gif">
						</div>
						<div class="item-info">
							<h4 :title="item.title">{{ item.title }}</h4>
							<p :title="item.abstract" v-html="item.abstract"></p>
						</div>
					</router-link>
				</div>
				
				<!-- 空数据 -->
				<el-empty v-if="updatesList.length === 0" :image-size="200"></el-empty>

				<!-- 分页 -->
				<div class="page-box">
					<pagination
						:total='pageTotal'
						:page="page"
						:pageSize='pageSize'
						@currentPage="handleCurrentChange">
					</pagination>
				</div>
			</div>

			<!-- 右部分 -->
			<DetailOther />
		</div>
		
		<!-- 页脚 -->
		<BottomFooter />
		
		<!-- 在线客服 -->
		<OnlineService />
	</div>
</template>

<script>
	const ItemTitle = () => import('../../components/ItemTitle');
	const DetailOther = () => import('../../components/DetailOther');
	const TopHeader = () => import('../../components/TopHeader');
	const Banner = () => import('../../components/Banner');
	const BottomFooter = () => import('../../components/BottomFooter');
	const OnlineService = () => import('../../components/OnlineService');
	const Pagination = () => import('../../components/Pagination');

	export default {
		name: 'LatestUpdates',
		components: {
			TopHeader,
			Banner,
			ItemTitle,
			DetailOther,
			OnlineService,
			Pagination,
			BottomFooter
		},
		data() {
			return {
				page: 1,
				pageSize: 8,
				pageTotal: 0,
				updatesList: [],
				defaultImg: 'this.src="' + require('../../assets/img/default_pic.png') + '"' // 默认封面
			}
		},
		mounted() {
			this._getNewest();
		},
		methods: {
			// 翻页
			handleCurrentChange(val) {
				this.page = val;
				this._getNewest();
			},
			// 获取最新更新
			_getNewest() {
				let params = `?PageNumber=${this.page}&PageSize=${this.pageSize}&OrderByDictionary[DisplayIndex]=desc&OrderByDictionary[CreationDate]=desc`;

				let nowDate = this.getDateFn(),
					data = 0,
					createionDate = '';

				this.$fetch('/api/information' + params).then((res) => {
					// 大于小于两个月(60天)的书显示new标志
					for (let i = 0; i < res.data.length; i++) {
						createionDate = res.data[i].creationDate.split(' ')[0];
						data = this.getDaysBetween(createionDate, nowDate);
						res.data[i].isNew = data <= 60 ? true : false;
					}

					this.updatesList = res.data;

					let headerData = JSON.parse(res.headers["x-pagination"]);
					this.pageTotal = headerData.totalCount;
				}).catch((err) => {
					throw err;
				});
			},
			// 判断两个日期相差多少天
			getDaysBetween(dateString1, dateString2) {
				var startDate = Date.parse(dateString1);
				var endDate = Date.parse(dateString2);
				if (startDate > endDate) {
					return 0;
				}
				if (startDate == endDate) {
					return 1;
				}
				var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
				return days;
			},
			// 获取当前时间的年月日
			getDateFn() {
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				if (month < 10) {
					month = "0" + month;
				}
				if (day < 10) {
					day = "0" + day;
				}
				return year + "-" + month + "-" + day;
			}
		}
	}
</script>

<style scoped>
	@import './common.css';
</style>



// WEBPACK FOOTER //
// src/pages/LatestUpdates/LatestUpdates.vue